<template>
	<div id="app">
		<van-nav-bar v-if="showNavBar" :title="title" left-arrow ref="navBar" fixed placeholder @click-left="goBack"
			:border="true"></van-nav-bar>
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" class="keep" />
		</keep-alive>

		<router-view v-if="!$route.meta.keepAlive" />

		<FloatBall />
	</div>
</template>

<script>
export default {
	components: {
		FloatBall: () => import("./components/FloatBall")
	},

	computed: {
		title() {
			return this.$store.state.app.title;
		},

		platformType() {
			return this.$store.state.app.platformType;
		},

		showNavBar() {
			if (this.platformType.win || this.platformType.iOS) {
				return true;
			}
			return false;
		},
	},

	methods: {
		goBack() {
			this.$goPage(-1);
		},
	},

	mounted() {
		budo_log.debug("#45 movie app mounted", location)

		Object.keys(this.platformType).forEach((key) => {
			if (this.platformType[key]) {
				budo_log.debug("#35 当前运行环境 ->", key);
			}
		});
	},
};
</script>

<style lang="scss">
@import "./styles/index.scss";

html,
body,
#app {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	font-family: Avenir, Helvetica, Arial, sans-serif !important;
	-webkit-font-smoothing: antialiased;
}

#app {
	display: flex;
	flex-direction: column;
}

.van-nav-bar {
	.van-icon-arrow-left {
		color: $second-color !important;
	}
}
</style>
